import { el, setChildren, setAttr } from '/lib/redom.es.js';
import Configuration from '/configuration/index.js';

const applicationConfiguration = Configuration.get();

class SVG {

  constructor(configuration) {

    this.initialized = false;

    this.src = applicationConfiguration.cdnAddress + (configuration.src || '');
    // eslint-disable-next-line no-undef
    this.img = new Image();
    this.img.src = this.src;
    this.img.onload = () => { delete this.img; };

    this.el = el('div', {
      id: configuration.id || '',
      class: configuration.class || '',
      style: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        height: '100%'
      }
    });

  }

  onmount() {
    this.initialize();
  }

  stringToSVG(svgString) {

    const element = document.createElement('div');

    element.innerHTML = svgString;

    return element.firstChild;

  }

  async load() {

    const response = await fetch(this.src);

    return response.text();

  }

  async initialize() {

    if (this.initialized === true) {
      return;
    }

    this.initialized = true;

    const svgString = await this.load();

    setChildren(this.el, [this.stringToSVG(svgString)]);

  }

  update(options) {

    this.initialized = false;

    this.src = applicationConfiguration.cdnAddress + options.src;

    if (typeof options.class === 'string') {
      setAttr(this.el, {
        class: options.class
      });
    }

    this.initialize();

  }

}

export default SVG;